import CombineButton from "./CombineButton";
import CutButton from "./CutButton";
import DeleteButton from "./DeleteButton";
import LineStringButton from "./LineStringButton";
import PointButton from "./PointButton";
import PolygonButton from "./PolygonButton";
import PolygonSelectButton from "./PolygonSelectButton";
import RedoButton from "./RedoButton";
import SelectButton from "./SelectButton";
import SnappingButton from "./SnappingButton";
import SplitButton from "./SplitButton";
import UncombineButton from "./UncombineButton";
import UndoButton from "./UndoButton";
import UnionButton from "./UnionButton";

type ToolbarGroupType = "mode" | "action";

export type ToolbarGroup = {
  id: string;
  type: ToolbarGroupType;
  items: React.ReactElement[];
};
export type ToolbarConfig = ToolbarGroup[];

/**
 * Default drawing tools when drawing any feature type
 */
export const defaultToolbarConfig: ToolbarConfig = [
  {
    id: "mainActions",
    type: "mode",
    items: [<SelectButton key="select" />, <PolygonButton key="drawPolygon" />, <PointButton key="drawPoint" />],
  },
  {
    id: "drawTools",
    type: "action",
    items: [
      <SnappingButton key="snap" />,
      <CutButton key="cut" />,
      <SplitButton key="split" />,
      <UnionButton key="union" />,
      <CombineButton key="combine" />,
      <UncombineButton key="uncombine" />,
    ],
  },
  {
    id: "historyTools",
    type: "action",
    items: [<UndoButton key="undo" />, <RedoButton key="redo" />, <DeleteButton key="delete" />],
  },
];

/**
 * Default drawing tools when drawing polygons
 */
export const polygonDrawingConfig: ToolbarConfig = [
  {
    id: "mainActions",
    type: "mode",
    items: [<SelectButton key="select" />, <PolygonButton key="drawPolygon" />],
  },
  {
    id: "drawTools",
    type: "action",
    items: [
      <SnappingButton key="snap" />,
      <CutButton key="cut" />,
      <SplitButton key="split" />,
      <UnionButton key="union" />,
      <CombineButton key="combine" />,
      <UncombineButton key="uncombine" />,
    ],
  },
  {
    id: "historyTools",
    type: "action",
    items: [<UndoButton key="undo" />, <RedoButton key="redo" />, <DeleteButton key="delete" />],
  },
];

/**
 * Default drawing tools when drawing points
 */
export const pointDrawingConfig: ToolbarConfig = [
  {
    id: "mainActions",
    type: "mode",
    items: [<SelectButton key="select" />, <PolygonSelectButton key="selectPolygon" />],
  },
  {
    id: "drawTools",
    type: "mode",
    items: [<PointButton key="drawPoint" />],
  },
  {
    id: "snappingTools",
    type: "action",
    items: [<SnappingButton key="snap" />],
  },
  {
    id: "historyTools",
    type: "action",
    items: [<UndoButton key="undo" />, <RedoButton key="redo" />, <DeleteButton key="delete" />],
  },
];

/**
 * Default drawing tools when drawing line strings
 */
export const lineStringDrawingConfig: ToolbarConfig = [
  {
    id: "mainActions",
    type: "mode",
    items: [<SelectButton key="select" />, <PolygonSelectButton key="selectPolygon" />],
  },
  {
    id: "drawTools",
    type: "mode",
    items: [<LineStringButton key="drawLineString" />],
  },
  {
    id: "snappingTools",
    type: "action",
    items: [<SnappingButton key="snap" />],
  },
  {
    id: "historyTools",
    type: "action",
    items: [<UndoButton key="undo" />, <RedoButton key="redo" />, <DeleteButton key="delete" />],
  },
];

/**
 * Default drawing tools when drawing points and line strings
 */
export const lineStringPointDrawingConfig: ToolbarConfig = [
  {
    id: "mainActions",
    type: "mode",
    items: [<SelectButton key="select" />, <PolygonSelectButton key="selectPolygon" />],
  },
  {
    id: "drawTools",
    type: "mode",
    items: [<PointButton key="drawPoint" />, <LineStringButton key="drawLineString" />],
  },
  {
    id: "snappingTools",
    type: "action",
    items: [<SnappingButton key="snap" />],
  },
  {
    id: "historyTools",
    type: "action",
    items: [<UndoButton key="undo" />, <RedoButton key="redo" />, <DeleteButton key="delete" />],
  },
];
